import { Dialog, DialogContent } from "@getgreenline/blaze-ui";
import { BrandUserAssignmentForm } from "./brand-user-assignment-form";

type AssignBrandUserDialogProps = {
  brand: { id: string; name: string };
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AssignBrandUserDialog({
  brand,
  open,
  onOpenChange,
}: AssignBrandUserDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw:max-w-lg">
        <BrandUserAssignmentForm
          brand={brand}
          onCancel={() => onOpenChange(false)}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
